import React from 'react';
import { POLIS_FEE } from '../../../App';

function ContractCheckbox({ data, selected = [], onSelectChange = () => {} }) {
  console.log('data:', data);

  if (POLIS_FEE.includes(data?.product_name) && data?.iafPolis !== true) {
    return null;
  }

  if (
    data?.pinvInvoice?.length > 0 ||
    data?.invoice_on === false ||
    data?.contract_value === 0
  ) {
    return null;
  }

  return (
    <input
      type="checkbox"
      checked={selected.includes(data._id)}
      onChange={(e) => {
        e.stopPropagation();
        onSelectChange(data);
      }}
    />
  );
}

export default ContractCheckbox;
